import { render, staticRenderFns } from "./PageEditorContentPanel.vue?vue&type=template&id=c033c88a&scoped=true"
import script from "./PageEditorContentPanel.vue?vue&type=script&lang=js"
export * from "./PageEditorContentPanel.vue?vue&type=script&lang=js"
import style0 from "./PageEditorContentPanel.vue?vue&type=style&index=0&id=c033c88a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c033c88a",
  null
  
)

export default component.exports